import React from "react";
import WatchWithHilalApp from "./WatchWithHilalApp";

function App() {
  return <WatchWithHilalApp />;
}

export default App;
